import { useSelector } from "react-redux";
import { useState } from "react";

import { clearSession } from "../../utils/initiate";
import { useTranslation } from "react-i18next";
import CONFIG from '../../config';
import "./index.css";

const Documents = () => {
  const { t } = useTranslation();
  const userData = useSelector(({ User }) => User.data);

  let link = CONFIG.apiURL2 + `/document-vault/${userData.UserId}`;
  return (
    <div className="wallet">
      <div className="page-title-box">
        <h4 className="page-title my-2">{t("sideNav.documentWallet")}</h4>
      </div>
      <div className="card">
        <div className="card-body pb-3">
          <div className="d-flex mt-2">
            <iframe
              id="fr"
              name="FormData"
              width="100%"
              height="600px"
              src={link}
              allow=""
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Documents;
